import Slider, { SliderProps } from '@mui/material/Slider'
import { SyntheticEvent } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

// --------------------------------------------------------------------------------------------- //

interface IProps {
  name: string
  onChangeCallback?: (arg0: SyntheticEvent) => void
}

type Props = IProps & SliderProps

export function RHFSlider({ name, onChangeCallback, ...other }: Props) {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, ...field } }) => (
        <Slider
          {...field}
          valueLabelDisplay="auto"
          {...other}
          onChange={(e, value) => {
            onChange(e)
            // @ts-ignore
            onChangeCallback?.({ target: { value } })
          }}
        />
      )}
    />
  )
}
